import { render, staticRenderFns } from "./FUmkmTypeDialog.vue?vue&type=template&id=5a921c66&scoped=true"
import script from "./FUmkmTypeDialog.vue?vue&type=script&lang=js"
export * from "./FUmkmTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a921c66",
  null
  
)

export default component.exports